module.exports = __webpack_public_path__ + "img/logo_fondo_obscuro.278429c7.png";